import { IsOptional, IsString } from "class-validator";

export class ReverseMoveUpDto {
  @IsOptional()
  @IsString()
  reason?: string;
}
